import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import CompanyProfile from './CompanyProfile';
import SecuritySettings from './SecuritySettings';
import UserManagement from './UserManagement';
import { getUserFlags } from '../helper';
import '.././styles/settings.scss';

function Settings() {
    const [activeTab, setActiveTab] = useState('CompanyProfile');

    const flags        = getUserFlags();
    const showUserMgmt = flags.is_platform_admin || flags.is_org_admin
        || flags.role_slug === 'mssp' || flags.role_slug === 'tam';

    const renderTabContent = () => {
        switch (activeTab) {
            case 'CompanyProfile':   return <CompanyProfile />;
            case 'SecuritySettings': return <SecuritySettings />;
            case 'UserManagement':   return <UserManagement />;
            default:                 return null;
        }
    };

    return (
        <div className='cstm_settings_tabs mt-2'>
            <Nav
                variant="pills"
                activeKey={activeTab}
                onSelect={(selectedKey) => setActiveTab(selectedKey)}
            >
                <Nav.Item>
                    <Nav.Link eventKey="CompanyProfile">Company Profile</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="SecuritySettings">Security Settings</Nav.Link>
                </Nav.Item>
                {/* {showUserMgmt && (
                    <Nav.Item>
                        <Nav.Link eventKey="UserManagement">User Management</Nav.Link>
                    </Nav.Item>
                )} */}
            </Nav>

            <div className="mt-3 wrp_setting_container">
                {renderTabContent()}
            </div>
        </div>
    );
}

export default Settings;
